export const GET_DRAMA_PENDING = 'tvdetail/GET_DRAMA_PENDING';
export const GET_DRAMA_SUCCESS = 'tvdetail/GET_DRAMA_SUCCESS';
export const GET_DRAMA_FAILURE = 'tvdetail/GET_DRAMA_FAILURE';
export const GET_SIMILAR_DRAMA_PENDING = 'tvdetail/GET_SIMILAR_DRAMA_PENDING';
export const GET_SIMILAR_DRAMA_SUCCESS = 'tvdetail/GET_SIMILAR_DRAMA_SUCCESS';
export const GET_SIMILAR_DRAMA_FAILURE = 'tvdetail/GET_SIMILAR_DRAMA_FAILURE';